const translations = {
	en: {
		sidebar: {
			dashboard: "Dashboard",
			grades: "Grades",
			assessments: "Assessments",
			lectures: "Lectures",
			weeklyReport: "Weekly Report",
			attendance: "Attendance",
			myDepartment: "My Department",
			teachers: "Teachers",
			subjects: "Subjects",
			classes: "Classes",
			parents: "Parents",
			settings: "Settings",
			logout: "Logout",
			grade: "grade",
		},
		calendar: {
			daysOfWeek: {
				monday: "Mon",
				tuesday: "Tue",
				wednesday: "Wed",
				thursday: "Thu",
				friday: "Fri",
				saturday: "Sat",
				sunday: "Sun",
			},
			months: {
				january: "January",
				february: "February",
				march: "March",
				april: "April",
				may: "May",
				june: "June",
				july: "July",
				august: "August",
				september: "September",
				october: "October",
				november: "November",
				december: "December",
			},
		},
		timetable: {
			periods: {
				first: "1st Period",
				second: "2nd Period",
				third: "3rd Period",
				fourth: "4th Period",
				fifth: "5th Period",
				sixth: "6th Period",
				seventh: "7th Period",
			},
			breaks: {
				main: "Break",
				second: "Break 2",
			},
		},
		// New assessment translations
		assessment: {
			assessmentManagement: "Assessment Management",
			semester: "Semester",
			firstSemester: "First Semester",
			secondSemester: "Second Semester",
			subject: "Subject",
			loadingSubjects: "Loading subjects...",
			selectSubject: "Select a subject",
			addNewAssessment: "Add New Assessment",
			assessmentTitle: "Assessment Title",
			enterTitle: "Enter assessment title",
			assessmentType: "Assessment Type",
			points: "Points",
			month: "Month",
			addAssessment: "Add Assessment",
			hideForm: "Hide Form",
			monthlyAssessments: "Monthly Assessments",
			pts: "pts",
			pointsTotal: "Points Total",
			assessments: "Assessments",
			noAssessmentsForMonth: "No assessments found for {month}",
			loadingAssessments: "Loading assessments...",
			pointsLabel: "points",
			deleteAssessment: "Delete Assessment",
			gradeAssessments: "Grade Assessment",
			grades: "Grades",
			type: "Type",
			totalPoints: "Total Points",
			date: "Date",
			totalStudents: "Total Students",
			graded: "Graded",
			average: "Average",
			loadingStudents: "Loading students...",
			studentGrades: "Student Grades",
			noStudentsFound: "No students found for this assessment",
			loading: "Loading...",
		},
		common: {
			save: "Save",
			saving: "Saving...",
			cancel: "Cancel",
			close: "Close",
			edit: "Edit",
			delete: "Delete",
			confirm: "Confirm",
			error: "Error",
			success: "Success",
		},
	},
	ar: {
		sidebar: {
			dashboard: "لوحة التحكم",
			grades: "الدرجات",
			assessments: "التقييمات",
			lectures: "المحاضرات",
			weeklyReport: "التقرير الأسبوعي",
			attendance: "الحضور",
			myDepartment: "قسمي",
			teachers: "المعلمون",
			subjects: "المواد",
			classes: "الصفوف",
			parents: "أولياء الأمور",
			settings: "الإعدادات",
			logout: "تسجيل الخروج",
			grade: "صف",
		},
		calendar: {
			daysOfWeek: {
				monday: "الإثنين",
				tuesday: "الثلاثاء",
				wednesday: "الأربعاء",
				thursday: "الخميس",
				friday: "الجمعة",
				saturday: "السبت",
				sunday: "الأحد",
			},
			months: {
				january: "يناير",
				february: "فبراير",
				march: "مارس",
				april: "أبريل",
				may: "مايو",
				june: "يونيو",
				july: "يوليو",
				august: "أغسطس",
				september: "سبتمبر",
				october: "أكتوبر",
				november: "نوفمبر",
				december: "ديسمبر",
			},
		},
		timetable: {
			periods: {
				first: "الحصة الأولى",
				second: "الحصة الثانية",
				third: "الحصة الثالثة",
				fourth: "الحصة الرابعة",
				fifth: "الحصة الخامسة",
				sixth: "الحصة السادسة",
				seventh: "الحصة السابعة",
			},
			breaks: {
				main: "استراحة",
				second: "استراحة ثانية",
			},
		},
		// New assessment translations in Arabic
		assessment: {
			assessmentManagement: "إدارة التقييمات",
			semester: "الفصل الدراسي",
			firstSemester: "الفصل الأول",
			secondSemester: "الفصل الثاني",
			subject: "المادة",
			loadingSubjects: "جارٍ تحميل المواد...",
			selectSubject: "اختر مادة",
			addNewAssessment: "إضافة تقييم جديد",
			assessmentTitle: "عنوان التقييم",
			enterTitle: "أدخل عنوان التقييم",
			assessmentType: "نوع التقييم",
			points: "النقاط",
			month: "الشهر",
			addAssessment: "إضافة تقييم",
			hideForm: "إخفاء النموذج",
			monthlyAssessments: "التقييمات الشهرية",
			pts: "نقطة",
			pointsTotal: "مجموع النقاط",
			assessments: "التقييمات",
			noAssessmentsForMonth: "لا توجد تقييمات لشهر {month}",
			loadingAssessments: "جارٍ تحميل التقييمات...",
			pointsLabel: "نقاط",
			deleteAssessment: "حذف التقييم",
			gradeAssessments: "تقدير التقييم",
			grades: "الدرجات",
			type: "النوع",
			totalPoints: "إجمالي النقاط",
			date: "التاريخ",
			totalStudents: "إجمالي الطلاب",
			graded: "مُقيّم",
			average: "المتوسط",
			loadingStudents: "جارٍ تحميل الطلاب...",
			studentGrades: "درجات الطلاب",
			noStudentsFound: "لم يتم العثور على طلاب لهذا التقييم",
			loading: "جارٍ التحميل...",
		},
		common: {
			save: "حفظ",
			saving: "جارٍ الحفظ...",
			cancel: "إلغاء",
			close: "إغلاق",
			edit: "تعديل",
			delete: "حذف",
			confirm: "تأكيد",
			error: "خطأ",
			success: "نجح",
		},
	},
};

export default translations;
